import Image from "next/image";
import React from "react";
import { searchableSelect } from "../CommonForm/CommonFormInterface";
import Input from "../Input/Input";
import { useRouter } from "next/navigation";

const SearchBar = ({
  field,
  onBlur,
  onFocus,
  inputValue,
  showErrors,
  inputError,
  onChange,
  onKeyDown
}: {
  field: searchableSelect;
  onBlur: Function;
  onFocus: Function;
  inputValue: string;
  showErrors:any;
  inputError:any;
  onChange:Function;
  onKeyDown: Function;
}) => {
  const router = useRouter()
  return (
    <>
      <div
        className={field?.className}
        style={{
          padding: "13px",
          ...(field?.searchbarStyle ?? {}),
        }}
      >
        <Image
          alt={"Search"}
          src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/search_icon.svg`}
          height={24}
          width={24}
          onError={(e) => null}
          // style={{ position: "absolute", top: "8px", left: "10px", }}
          priority={true}
        />
        <Input
          inputId={`search_bar_${field?.id}`}
          style={{
            position: "relative",
            padding: "0px 10px 0px 13px",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            width: "91%",
            display: "inline-block",
            color: "rgb(12, 17, 29)",
            boxShadow: "none",
            textDecoration: "none",
            borderRadius: "50px",
            background: "transparent",
            border: "none",
            ...field?.inputStyle
          }}
          field={field}
          onFocus={onFocus}
          onBlur={onBlur}
          autoFocus={field?.autoFocus ?? true}
          inputValue={inputValue}
          showErrors={showErrors}
          inputError={inputError}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        {field?.showInnerCross && (
          <div onClick={()=>{router.back();}}>
            <Image
              alt={"Cross"}
              src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/crossIcon.png`}
              height={18}
              width={18}
              onError={(e) => null}
              // style={{ position: "absolute", top: "8px", left: "10px", }}
              priority={true}
            />
          </div>
        )}
      </div>
    </>
  )
};

export default SearchBar;
